import React from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from "@/hooks/useTranslation";

const FlashEmptyPhotosphere = () => {
    const { t } = useTranslation()
    return (
        <motion.div
            key="flash-blackout"
            className="absolute inset-0 w-full h-full anti-flashbang flex items-center justify-center select-none z-[10]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
        >
            <div className="text-center text-white">
                <div className="text-xl md:text-3xl mt-2">{t('play.flash.makeYourGuess')}</div>
                <div className="text-lg md:text-2xl mt-2 text-gray-400">{t('play.flash.onlyCorrectMap')}</div>
            </div>
        </motion.div>
    )
}

export default FlashEmptyPhotosphere